// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ia2b","toggleWrap":"styles_toggleWrap__2QZpT","content":"styles_content__1qCgt","selectAreaCode":"styles_selectAreaCode__3Py9U"};